(function () {
  function setupMobileNavTapToOpen() {
    const nav = document.querySelector('#Mobile-Nav');
    if (!nav) return;

    nav.addEventListener('click', function (e) {
      const link = e.target.closest('a.f-mobile-nav__link, a.f-mobile-nav__sub-link');
      if (!link) return;

      const li = link.closest('li');
      if (!li) return;

      // Solo queremos interceptar cuando ese item tiene hijos (submenu)
      const hasChildren = li.classList.contains('f-mobile-nav__item--has-child') ||
                          li.classList.contains('f-mobile-nav__sub-item--has-child') ||
                          li.querySelector('collapsible-tab');

      if (!hasChildren) return;

      // Si ya está abierto, dejamos que el click navegue (comportamiento normal)
var content = li.querySelector('[data-content]');
var contentIsOpen =
  content &&
  content.classList &&
  content.classList.contains('is-open');

var alreadyOpen =
  li.classList.contains('is-open') ||
  li.classList.contains('open') ||
  li.getAttribute('aria-expanded') === 'true' ||
  contentIsOpen;

if (alreadyOpen) return;


      // Primer toque: abrir en vez de navegar
      e.preventDefault();

      // Simulamos el click en el trigger (+)
      const trigger = li.querySelector('[data-trigger]');
      if (trigger) trigger.click();
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupMobileNavTapToOpen);
  } else {
    setupMobileNavTapToOpen();
  }
})();
